import {createBrowserRouter} from "react-router-dom";
import App from './App.jsx';
import Login from './pages/Login/Login.jsx';
import MyRequests from './pages/MyRequests/MyRequests.jsx';
import MyProfile from './pages/MyProfile/MyProfile.jsx';
import EACity from './pages/EntrepreneurshipAnalytics/EACity.jsx';
import EAMsp from './pages/EntrepreneurshipAnalytics/EAMsp.jsx';
import EAPICreative from './pages/EntrepreneurshipAnalytics/PriorityIndustries/EAPICreative.jsx';
import EAPIProcessingIndustry
    from './pages/EntrepreneurshipAnalytics/PriorityIndustries/EAPIProcessingIndustry.jsx';
import EAPITourism from './pages/EntrepreneurshipAnalytics/PriorityIndustries/EAPITourism.jsx';
import EABusinessClimate from './pages/EntrepreneurshipAnalytics/EABusinessClimate.jsx';
import Analytics from './pages/Analytics/Analytics.jsx';
import GeoCityMap from './pages/DigitalMap/GeoCityMap.jsx';
import GeoCreativeInfra from './pages/DigitalMap/GeoCreativeInfra.jsx';
import GeoManufacturerSites from './pages/DigitalMap/GeoManufacturerSites.jsx';
import RequestsCerts from './pages/Requests/RequestsCerts/RequestsCerts.jsx';
import RequestsIndustrialSites
    from './pages/Requests/RequestsIndustrialSites/RequestsIndustrialSites.jsx';
import RequestsInvestRegistry
    from './pages/Requests/RequestsInvestRegistry/RequestsInvestRegistry.jsx';
import RequestsConsulting from './pages/Requests/RequestConsulting/RequestsConsulting.jsx';
import RequestsKTA from './pages/Requests/RequestsKTA/RequestsKTA.jsx';
import AdminUsers from './pages/AdminUsers/AdminUsers.jsx';

const router = createBrowserRouter(
    [
        {
            path: '/',
            element: <App />,
            children: [
                {path: '/requests/my-applications', element: <MyRequests />},
                {path: '/my-profile', element: <MyProfile />},
                {path: '/requests/certificates', element: <RequestsCerts />},
                {path: '/requests/industrial-sites', element: <RequestsIndustrialSites />},
                {path: '/requests/invest-registry', element: <RequestsInvestRegistry />},
                {path: '/requests/kta', element: <RequestsKTA />},
                {path: '/requests/consulting', element: <RequestsConsulting />},
                {path: '/analytics', element: <Analytics />},
                {path: '/analytics/city', element: <EACity />},
                {path: '/analytics/msp', element: <EAMsp />},
                {path: '/analytics/creative', element: <EAPICreative />},
                {path: '/analytics/processing', element: <EAPIProcessingIndustry />},
                {path: '/analytics/tourism', element: <EAPITourism />},
                {path: '/analytics/climate', element: <EABusinessClimate />},
                {path: '/geo/city', element: <GeoCityMap />},
                {path: '/geo/creative', element: <GeoCreativeInfra />},
                {path: '/geo/manufacturers', element: <GeoManufacturerSites />},
                {path: '/admin/users', element: <AdminUsers/>}
            ]
        },
        {
            path: '/auth/login',
            element: <Login/>
        }
    ]
)

export default router